<template>
    <div>
        <h1 class="page-title">Monitoring Ogloba</h1>
    </div>
    <div class="card">
        <DataTable
            :value="tableData"
            :rows="rows"
            editMode="row"
            v-model:editingRows="editingRows"
            @row-edit-save="onRowEditSave"
            class="p-datatable-custom"
            :rowsPerPageOptions="[10,25, 100]"
            paginator
        >
            <template #header>
                <div class="search-container">
                <span class="p-input-icon-left">
            <FormKit
                type="select"
                name="filterAlertStatus"
                :options="[     {label:'Statut du traitement', value:''},
                                { label: 'A traiter', value: '0' },
                                { label: 'En cours', value: '1' },
                                { label: 'Traité', value: '2' },
                            ]"
                @change="filterByAlertStatus"
            />
                </span>
                </div>
            </template>
            <div class="card-body pt-0">
                <Column field="created" header="Date"  class="whitespace-nowrap"/>
                <Column field="id" header="Numéro de commande"  class="whitespace-nowrap">
                    <template #body="slotProps">
                        <a :href="appLegacyUrl+'admin/order/detail/'+slotProps.data.id"
                           class="p-button-success ml-2" target="_blank">
                            <Button size="small" icon="pi pi-eye" class="p-button-eye "
                                    style="margin-right: 0.5em" title="Voir Commande">
                            </Button>
                        </a>
                    </template>
                </Column>
                <Column header="Statut de la commande"  class="whitespace-nowrap">
                    <template #body="slotProps">
                        <div class="badge border-white text-purple-800 bg-purple-200 p-4 ml-2">{{ getLabelStatus(slotProps.data.orderSupplierState) }}</div>
                            
                    </template>
                </Column> 
                <Column field="firstname" header="Utilisateur">
                    <template #body="slotProps">
                        {{ slotProps.data.firstname + ' ' + slotProps.data.lastname }}
                        <br>
                        {{ slotProps.data.email }}
                    </template>
                </Column>
                <Column field="alertMotifs" header="Motif d’alerte" class="whitespace-nowrap"  >
                    <template #body="slotProps">
                            <div v-for="motif in slotProps.data.alertMotifs">
                                * {{ motif }} 
                            </div>
                    </template>
                </Column>
                <Column field="voucherUrls" header="Liens html ou pdf"  class="whitespace-nowrap">
                    <template #body="slotProps">
                        <ul>
                            <li v-for="link in slotProps.data.voucherLinks">
                                <a :href="link" class="p-button-success ml-2" target="_blank">
                                    <Button
                                        size="small"
                                        icon="pi pi-download"
                                        class="p-button-success"
                                        style="margin-right: 0.5em"
                                        title="Télécharger le voucher"
                                    />
                                </a>
                            </li>
                        </ul>
                    </template>
                </Column>
                <Column field="voucherStatus" header="Statut vouchers"  class="whitespace-nowrap"> 
                    <template #body="slotProps">
                        <Button v-if="slotProps.data.voucherRefs.length" size="small" icon="pi pi-eye"
                                class="p-button-info p-button-eye"
                                style="margin-right: 0.5em" title="Voir status"
                                @click="openVoucherStatusModal(slotProps.data.id,slotProps.data.voucherRefs)">
                        </Button>
                    </template>
                </Column>
                <Column field="alertStatus" header="Statut du traitement" class="whitespace-nowrap">
                    <template #body="slotProps">
                        <FormKit
                            type="select"
                            name="ssss"
                            
                            v-model="slotProps.data.alertStatus"
                            :options="[
                                { label: 'A traiter', value: '0' },
                                { label: 'En cours', value: '1' },
                                { label: 'Traité', value: '2' },
                            ]"
                            @change="updateAlertStatus($event,slotProps.data)"
                        />
                    </template>
                </Column>
                <Column field="alertComment" header="Commentaire">
                    <template #editor="{ data, field }">
                        <FormKit
                            type="text"
                            :name="field"
                            v-model="data[field]"
                            @input="value => data[field] = value"
                            validation="length:0,50"
                            :validation-messages="{
                               length: 'Le commentaire ne peut pas dépasser 50 caractères',
                               }"
                        />
                    </template>
                </Column>
                <Column :rowEditor="true" style=" position: relative; "></Column>
                <Column field="alertUpdatedBy" header="Agent"/>
            </div>
            <template #empty>Aucun résultat trouvé.</template>
        </DataTable>
        <OglobaVoucherStatusModal :voucherRefs="voucherRefs"
                                  :orderSupplierId="orderSupplierId"></OglobaVoucherStatusModal>
    </div>
</template>

<script lang="ts" setup>
import Column from "primevue/column";
import Button from "primevue/button";
import DataTable from "primevue/datatable";
import {ref, onMounted} from "vue";
import ApiService from "@/_services/api.service";
import swal from "@/_helpers/swal";
import OglobaVoucherStatusModal from "./OglobaVoucherStatusModal.vue"

let rows = ref<number>(10);
const vouchers = Array<Document>();
let tableData = ref<Array<Document>>(vouchers);
let totalRecords = ref<number>(0);
let voucherRefs = ref([]);
let orderSupplierId = ref('test');
const editingRows = ref([]);
const appLegacyUrl = ref();

onMounted(async () => {
    await fetchData('');
     appLegacyUrl.value = process.env.VUE_APP_LEGACY_URL  ;

});


const onRowEditSave = async (event) => {
    const { newData} = event;
    
    if (newData?.alertComment?.length > 50) {
        swal.error("Le commentaire ne peut pas dépasser 50 caractères")
        return;
    }
    
    try {
        await ApiService.post("/admin/order-supplier-alert", {
            orderSupplierUuid: newData.orderSupplierUuid,
            comment: newData.alertComment
        })
        await  swal.success("", "Commentaire modifié");
        location.reload();
    } catch (error) {
        //
    }
};

 function updateAlertStatus(event, row) {
    ApiService.post("/admin/order-supplier-alert", {
        orderSupplierUuid: row.orderSupplierUuid,
        status: parseInt(event.target.value)
    }).then(async ({data}) => {
       await  swal.success("", "Statut modifié");
        location.reload();
    }).catch(({response}) => {
        swal.error(response?.data?.errors[0]?.message);
    });

}

async function fetchData(
    status: ''
) {
    const params = {
        alertStatus: status
    }
    try {
        const {data} = await ApiService.get('admin/monitoring-ogloba-order', {
            headers: {Accept: 'application/ld+json'},
            params: params
        });
        totalRecords.value = data.data['hydra:totalItems'];
        tableData.value = [];
        data.data['hydra:member'].forEach((item) => {
            tableData.value.push(item);
        });
    } catch (error) {
        swal.error('An error occurred while fetching vouchers.');
    }
}


function filterByAlertStatus(event) {
    fetchData(event.target.value);
}

const openVoucherStatusModal = (rowId, vouchers: []) => {
    voucherRefs.value = vouchers;
    orderSupplierId.value = rowId;
    const voucherStatusModal: HTMLDialogElement | null = document.querySelector(`#ogloba-vocher-status-modal`);
    if (voucherStatusModal) {
        voucherStatusModal.showModal();
    }
};

function getLabelStatus(status) {
    switch (status) {
        case 0:
            return 'En attente';
        case 1:
            return 'Préparation';
        case 2:
            return 'Expédiée';
        case 5:
            return 'Remboursée';
        case 8:
            return 'Erreur';
        case 11:
            return 'Envoi partiel';
        default:
            return '';
    }
}
</script>
